module.exports = __webpack_public_path__ + "static/media/primeiro.6dc0313a.md";